import { Component, OnInit, Injector, Input, Output, EventEmitter } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { FilterableService } from '../../../../filterable-service';
import { WorkOrderNotificationService } from '../../../../ve.service';
import { AuthenticationService } from '../../../../../../auth.service';
import { bodyWoSubmitReportControls } from '../../body-work-orders.template';
import { Validators } from '@angular/forms';

@Component({
  selector: 'body-wo-submit-report-in-progress-form',
  templateUrl: './body-wo-submit-report-in-progress-form.component.html',
  styleUrls: ['../../dialogs/body-wo-submit-report-dialog/body-wo-submit-report-dialog.component.css',
  '../../../work-orders.component.scss']
})
export class BodyWoSubmitReportInProgressFormComponent implements OnInit {
  @Input()
  set data(dataItem: any) {
    //this is kept empty on purpose
  }
  readonly contactsFilterableService = new FilterableService();
  workOrderService: WorkOrdersService;
  workOrderNotificationService: WorkOrderNotificationService;
  authService: AuthenticationService;
  defaultContacts: any;
  defaultDate = new Date();
  isLoading = false;

  constructor(private readonly injector: Injector) {
    this.workOrderService = this.injector.get(WorkOrdersService);
    this.workOrderNotificationService = this.injector.get(WorkOrderNotificationService);
    this.authService = this.injector.get(AuthenticationService);
  }

  ngOnInit() {
    this.clearValidators();
    this.setValidators();
    this.isLoading = true;
    Promise.all([
      this.getDefaultContacts(),
      this.populateContactsList(),
    ])
    .then(() => this.isLoading = false)
    .catch(() => this.isLoading = false);
  }

  getDefaultContacts(): Promise<any> {
    return this.workOrderNotificationService.read('/Module/VE_Body')
      .then(response => {
        if (response) {
          response.forEach(element => {
            if (element.WorkOrderStatusId === this.workOrderService.bodyWoSubmitReportForm.value.StatusId) {
              const contacts = Object.assign([], element.ContactList);
              this.defaultContacts = contacts;
            }
          });
        }
      });
  }

  populateContactsList() {
    return this.workOrderNotificationService.read('/ContactsForModule/' + this.authService.getModule())
      .then(result => {
        if (result.length > 0) {
          result.sort();
        }
        this.contactsFilterableService.next(result);
      });
  }

  setValidators() {
    this.workOrderService.bodyWoSubmitReportForm.get('ActualStartDate').setValidators([Validators.required]);
    this.workOrderService.bodyWoSubmitReportForm.get('ActualStartDate').updateValueAndValidity();
  }

  clearValidators() {
    bodyWoSubmitReportControls.forEach(control => {
      this.workOrderService.bodyWoSubmitReportForm.get(control).clearValidators();
      this.workOrderService.bodyWoSubmitReportForm.get(control).updateValueAndValidity();
    });
  }

  onContactsChange(event: any) {
    const contacts = event;
    const emails = this.formatEmails(this.workOrderService.bodyWoSubmitReportForm.get('AdditionalEmailIds').value);
    const validContacts: boolean = contacts && (contacts.length > 0);
    const vaildEmails: boolean = emails && (emails !== '');

    if (validContacts || vaildEmails) {
      this.workOrderService.bodyWoSubmitReportForm.get('EmailNotes').enable();
    } else {
      this.workOrderService.bodyWoSubmitReportForm.get('EmailNotes').setValue('');
      this.workOrderService.bodyWoSubmitReportForm.get('EmailNotes').disable();
    }
  }

  /**
   * Convert string of emails to list of emails
   * @param otherEmails
   */
  formatEmails(otherEmails: any): string {
    if (otherEmails) {
        const emails: any[] = [];
        otherEmails.split('.com').forEach(element => {
            const x = element.replace(/[, ]+/g, ' ').trim();
            if (x && x !== '') {
                emails.push(x + '.com');
            }
        });
        return emails.join();
    }

    return null;
  }
}
